import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieGer = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose Germany as Your Study Destination?</h1>  
          <p>Germany offers a highly respected and often tuition-free higher education system, a rich history and culture, and a vibrant, international student community. </p>
        <p>Key Advantages:  </p>
        <ul>
           <li> World-Class Universities: Institutions like TU Munich and RWTH Aachen rank among the best globally  </li>
           <li>Affordable Education: Public universities offer tuition-free education for most international students. </li>
           <li>Career Prospects: Germany’s strong economy offers robust job opportunities for graduates.  </li>
           <li>Research & Innovation Hub: Germany is a global leader in research, engineering, IT, and healthcare.  </li>
           <li>Post-Study Work Opportunities: Graduates can stay up to 18 months to find employment.  </li>
           <li>Multicultural Experience: Safe, modern, and culturally diverse living environment.   </li>
        </ul>

        <hr />
        <table>
            <caption>Germany’s Higher Education System   </caption>
            <thead>
                <tr>
                    <th>Type </th>
                    <th>Features </th>
                </tr>
            </thead>
                <tr>
                    <td>Public Universities </td>
                    <td>Government-funded; focus on academic research; tuition-free for most programs </td>
                </tr>
        </table>
        <table>
            <caption>Germany’s Higher Education System   </caption>
            <thead>
                <tr>
                    <th>Comparison </th>
                    <th> Public Universities  </th>
                    <th>Private Universities </th>
                </tr>
            </thead>
                <tr>
                    <td>Tuition Fees  </td>
                    <td>Minimal (€100–€350 per semester) </td>
                    <td>€10,000–€15,000 annually</td>
                </tr>
                <tr>
                    <td>Admission Criteria  </td>
                    <td>Highly competitive  </td>
                    <td>Flexible requirements </td>
                </tr>
                <tr>
                    <td>Focus </td>
                    <td>Research and Academics </td>
                    <td>Industry-oriented programs</td>
                </tr>
                <tr>
                    <td>Instruction Language  </td>
                    <td> Primarily German, increasing English programs  </td>
                    <td>Mostly English-taught programs</td>
                </tr>
        </table>
        

        <hr />

        <h2>Top Public Universities in Germany </h2>

        <ul>
            <li>Technical University of Munich (TUM)  </li>
            <li>Heidelberg University  </li>
            <li>University of Stuttgart  </li>
            <li>RWTH Aachen University  </li>
            <li>Humboldt University of Berlin</li>
        </ul>  
        <hr/>
        <h2>Top Private Universities in Germany </h2>
        <ul>
            <li>WHU – Otto Beisheim School of Management </li>
            <li>Munich Business School  </li>
            <li>Frankfurt School of Finance & Management   </li>
            <li>EBS University of Business and Law</li>
        </ul> 
        <hr />
        <h2>Popular Courses in Germany </h2>
            <ul>
                <li>Mechanical, Automotive, and Aerospace Engineering</li>
                <li>Computer Science and Artificial Intelligence</li>
                <li>Business Management and Finance</li>
                <li>Medicine and Biomedical Sciences </li>
                <li>Data Science and Analytics </li>
                <li>Architecture and Urban Planning </li>
                <li>Renewable Energy and Environmental Sciences </li>
                <li>Supply Chain and Logistics Management</li>
                <li>Cybersecurity and Telecommunications </li>
                <li>Game Design and Digital Marketing </li>
            </ul>
            <hr />
            <h2>Germany Admission Requirements </h2>
             
            <table>
                <thead>
                    <tr>
                        <th>Criteria</th>
                        <th>Public Universities </th>
                        <th>Private Universities </th>
                    </tr>
                </thead>
                <tr>
                    <td>Minimum Qualification </td>
                    <td>12+4 years for Master’s</td>
                    <td>12+3 years accepted </td>
                </tr>
                <tr>
                    <td>Academic Score </td>
                    <td>Minimum 70% preferred</td>
                    <td>50–60% acceptable</td>
                </tr>
                <tr>
                    <td>Language Requirement </td>
                    <td>IELTS 6.5+ / TOEFL 90+ (English courses), B1/B2 for German programs </td>
                    <td>IELTS 6.0+ / TOEFL 80+ </td>
                </tr>
                <tr>
                    <td>Entrance Exams </td>
                    <td>GRE/GMAT may be required </td>
                    <td>Rarely required </td>
                </tr>
                <tr>
                    <td>Work Experience</td>
                    <td>Preferred for MBA/MS programs</td>
                    <td>Optional but beneficial </td>
                </tr>
            </table>
            <hr />
            <h2>Admission & Visa Checklist  </h2>
            <table>
                <thead>
                    <tr>
                        <th>Document</th>
                        <th>For Admission</th>
                        <th>For Visa </th>
                    </tr>
                </thead>
                <tr>
                    <td>Academic Transcripts</td>
                    <td>&#10004;</td>
                    <td>&#10004;</td>
                </tr>
                <tr>
                    <td>Statement of Purpose (SOP) </td>
                    <td>&#10004;</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Letters of Recommendation (LORs) </td>
                    <td>&#10004;</td>
                    <td></td>
                </tr>
                <tr>
                    <td>CV/Resume </td>
                    <td>&#10004;</td>
                    <td></td>
                </tr>
                <tr>
                    <td>English/German Language Test Scores</td>
                    <td>&#10004;</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Passport Copy </td>
                    <td>&#10004;</td>
                    <td>&#10004;</td>
                </tr>
                <tr>
                    <td>University Offer Letter </td>
                    <td>&#10004;</td>
                    <td>&#10004;</td>
                </tr>
                <tr>
                    <td>Proof of Blocked Account (€11,208) </td>
                    <td></td>
                    <td>&#10004;</td>
                </tr>
                <tr>
                    <td>Health Insurance</td>
                    <td>&#10004;</td>
                    <td>&#10004;</td>
                </tr>
                <tr>
                    <td>Visa Application Form</td>
                    <td></td>
                    <td>&#10004;</td>
                </tr>
                <tr>
                    <td>APS Certificate (mandatory for Indian students)</td>
                    <td>&#10004;</td>
                    <td>&#10004;</td>
                </tr>
            </table>
           <hr />

           <h2>Scholarships for International Students</h2>
             <table>
                <thead>
                    <tr>
                        <th>Scholarship</th>
                        <th>Benefits</th>
                    </tr>
                </thead>
                <tr>
                    <td>DAAD Scholarships</td>
                    <td>Full tuition, living stipend, travel expenses</td>
                </tr>
                <tr>
                    <td>Deutschlandstipendium</td>
                    <td>€300/month based on merit </td>
                </tr>
                <tr>
                    <td>Erasmus+ Program </td>
                    <td>Exchange and mobility funding</td>
                </tr>
                <tr>
                    <td>Heinrich Böll Foundation </td>
                    <td>Funding based on academic excellence and community leadership </td>
                </tr>
                <tr>
                    <td>Konrad-Adenauer-Stiftung Scholarships </td>
                    <td>Support for future leaders in politics, business, and academia</td>
                </tr>
             </table>
             <hr />
           <h2>Cost of Studying and Living in Germany </h2>
           <table>
               <thead>
                   <tr>
                        <th>Expense</th>
                        <th>Estimated Cost </th>
                   </tr>
               </thead>
               <tr>
                   <td>Tuition (Public Universities)</td>
                   <td>€100–€350/semester </td>
               </tr>
               <tr>
                   <td>Tuition (Private Universities)</td>
                   <td> €10,000–€15,000/year</td>
               </tr>
               <tr>
                   <td>Living Costs </td>
                   <td>€850–€1,200/month</td>
               </tr>
               <tr>
                   <td>Health Insurance </td>
                   <td>€80–€120/month</td>
               </tr>
               <tr>
                   <td>Public Transport Pass</td>
                   <td>€30–€70/month</td>
               </tr>
               <tr>
                   <td>Semester Contribution</td>
                   <td>€150–€500 </td>
               </tr>
           </table>
            <hr/>
            <h2>Work While Studying in Germany   </h2>
             <ul>
                <li>Students can work 140 full days or 280 half days per year.</li>
                <li>Average student wage: €12–€15/hour. </li>
                <li>Earnings below €520/month are tax-exempt.</li>
             </ul>
             <hr />
             <h2>Understanding APS Certification </h2>
             <table>
                <thead>
                    <tr>
                        <th>Step</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tr>
                    <td>Registration</td>
                    <td>Apply through APS India Portal </td>
                </tr>
                <tr>
                    <td>Documents</td>
                    <td>Submit academic transcripts, degree certificates, passport</td>
                </tr>
                <tr>
                    <td>Review</td>
                    <td>APS evaluates your academic credentials</td>
                </tr>
                <tr>
                    <td>Certification</td>
                    <td>Required to apply for a visa and university admission </td>
                </tr>
                <tr>
                    <td>Processing Time</td>
                    <td>4–8 weeks</td>
                </tr>
             </table>
             <p>APS (Academic Evaluation Centre) is now mandatory for Indian students applying to Germany. </p>
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieGer